export default __webpack_public_path__ + "static/media/640_store05-jp-web.d81aa51d.png";